<template>
<div id="CourseCurriculum">
  <ul>
    <li :class="['curriculum-list', {'enable': course.enable === COURSE_ENABLE}]" v-for="course in courseList" :key="course.pkid"  @click="goCourse(course)">
      <img :src="course.thumbnail" class="thumbnail">
      <div :class="['content',{'current': course.pkid === curCourse.pkid}]">
        <p class="title">
          <span class="living-course" v-if="course.state === COURSE_STATE.LIVING">直播中</span>
          <span>{{course.title}}</span>
        </p>
        <div class="wrap">
          <span class="time">{{course.dateString}}</span>
        </div>
      </div>
      <VuiButton
        class="signUp"
        :type="(course.pkid === curCourse.pkid ? curCourse.signUpFlag : course.signUpFlag) ? 'cancel' : 'warning'"
        @click.native.stop="courseSingUp(course)"
        v-if="course.state == 2 && course.enable === COURSE_ENABLE">{{(course.pkid === curCourse.pkid ? curCourse.signUpFlag : course.signUpFlag) ? '已报名' : '报名'}}</VuiButton>
    </li>
  </ul>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { courseFilter } from '@/utils'
import { COURSE_ENABLE, FISCAL_TAX, COURSE_STATE } from '@/constant/constants'
const offsetHeight = 700
export default {
  inject: ['reload'],
  props: {
    curCourse: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
      courseList: [],
      COURSE_ENABLE,
      page: {
        pageIndex: 1,
        pageSize: 20,
        total: 0,
      },
      loading: false,
      COURSE_STATE,
    }
  },
  computed: {
    ...mapState('app', {
      isLogin: state => state.isLogin,
      id: state => state.userinfo.id,
    }),
  },
  methods: {
    goCourse (course) {
      if (course.enable === COURSE_ENABLE) {
        this.$router.push({ name: 'LiveDetail', params: { courseId: course.pkid } })
      } else {
        this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: course.enableSign })
      }
    },
    courseSingUp (course) {
      if (!this.isLogin) {
        this.$Message.info('请先登录！')
        this.$router.push({ name: 'Login' })
        return
      }

      this.$store.dispatch('course/setCourseSingup', {
        courseId: course.pkid,
        signUpFlag: !course.signUpFlag,
      }).then(() => {
        course.signUpFlag = !course.signUpFlag
        this.$Message.info(course.signUpFlag ? '报名成功' : '取消成功')
        if (this.curCourse.pkid === course.pkid) {
          this.$emit('changeCourseProps', { course, prop: 'signUpFlag', value: course.signUpFlag })
        }
      }).catch(() => {
        this.$Message.info(course.signUpFlag ? '取消失败' : '报名失败')
      })
    },
    // 获取课程列表
    getCourseList () {
      let redirectType = sessionStorage.getItem('redirectType')
      this.loading = true
      if (redirectType) {
        this.$store.dispatch('course/getSystemCourseList', { systemMark: redirectType, userId: this.id })
          .then(result => {
            // 设置所有课程可用
            result.forEach(item => {
              item.enable = 1
            })
            let courseList = courseFilter(result, true)
            if (redirectType === FISCAL_TAX) { // 单独处理法税的权限
              this.$store.dispatch('course/getFiscalFilter', { userId: sessionStorage.getItem('tempUserId') }).then(res => {
                this.loading = false
                if (res.filter) {
                  this.courseList = courseList.filter(item => res.courseList.includes(item.pkid))
                } else {
                  this.courseList = courseList
                }
              })
            } else {
              this.courseList = courseList
            }
          })
      } else {
        this.$store.dispatch('course/getCourseList', this.page)
          .then(result => {
            this.courseList.push(...courseFilter(result.list, true))
            this.page.total = result.total
            this.loading = false
          })
      }
    },
    loadMore (ev) {
      // 加载更多
      if (this.$el.scrollHeight - offsetHeight < this.$el.scrollTop + this.$el.offsetHeight
          && this.page.total > this.courseList.length
          && !this.loading) {
        this.page.pageIndex = this.page.pageIndex + 1
        this.getCourseList()
      }
    },
  },
  mounted () {
    this.getCourseList()
    this.$el.addEventListener('scroll', this.loadMore)
  },
  destroyed () {
    this.$el.removeEventListener('scroll', this.loadMore)
  },
}
</script>

<style lang="scss">
#CourseCurriculum {
  padding-top: 64px;
  height: 100%;
  overflow-y: scroll;
  .curriculum-list{
    position: relative;
    padding: 16px 20px 16px 16px;
    display: flex;
    border-bottom: 1px solid #d8d8d8;
    cursor: pointer;
    transition: all .2s;
    align-items: center;
    &:hover {
      background: #eee;
    }
    &:not(.enable) {
      .title, .time, .signUp, .living-course {
        color: #ddd;
      }
    }
    img {
      flex-shrink: 0;
    }
  }
  .content {
    flex-grow: 1;
    margin-left: 16px;
    &.current {
      color: #ed6c00;
    }
  }

  .title {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    overflow: hidden;
    margin-bottom: 14px;
  }
  .tips {
    position: absolute;
    left: 18px;
    top: 18px;
    font-size: 12px;
    background: #000;
    color: #fff;
    border-radius: 2px;
    line-height: 1.5;
    padding: 0 5px;
  }
  .wrap {
    display: flex;
    justify-content: space-between;
  }

  .time {
    font-size: 12px;
    // letter-spacing: 0.2px;
    color: #868688;
    line-height: 24px;
  }

  .thumbnail {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .signUp {
    transition: width .3s;
    height: 30px;
    border-radius: 16px;
    font-size: 12px;
    line-height: 15px;
    flex-shrink: 0;
  }
  .living-course{
    margin-right: 8px;
    font-size: 12px;
    font-weight: 600;
    background: #57BD58;
    color: #fff;
    border-radius: 2px;
    padding: 4px;
  }
}
</style>
